export enum AuthenticationStatusEnum {
    LoggedIn = 'LoggedIn',
    TemporaryPassword = 'TemporaryPassword',
    Blocked = 'Blocked',
    Disbarred = 'Disbarred',
    InvalidUsername = 'InvalidUsername',
    InvalidPassword = 'InvalidPassword',
    GeneratedAccount = 'GeneratedAccount',
    LoggedOut = 'LoggedOut',
    Timeout = 'TimeOut',
    SessionExpired = 'SessionExpired',
    UnactivatedAndBlocked = 'UnactivatedAndBlocked',
    WelcomeDialogue = 'WelcomeDialogue',
    ChangeEmail = 'ChangeEmail',
    TwoFactor = 'TwoFactorAuthentication',
}
export interface SessionInterface {
    token?: string;
    sessionDurationInSeconds: number;
    sessionStart: Date;
    status?: AuthenticationStatusEnum;
}
